function main() {
  const infoElement = document.querySelector("#hidden-page-info");
  const data = JSON.parse(infoElement.innerHTML);

  // adding elements without duplication check
  if (data?.canonicalURL) {
    const canonicalLinkElement = document.createElement("link");
    canonicalLinkElement.rel = "canonical";
    canonicalLinkElement.href = data?.canonicalURL;
    document.head.appendChild(canonicalLinkElement);
  }

  if (data?.schema != {} && data?.schema) {
    const schemaMarkupElement = document.createElement("script");
    schemaMarkupElement.type = "application/ld+json";
    schemaMarkupElement.innerText = JSON.stringify(data?.schema ?? {});
    document.head.appendChild(schemaMarkupElement);
  }

  // adding items with duplication check and validity check
  const originalMetaDescriptionElement = document.querySelector(
    'meta[name="description"]',
  );

  if (data?.metaDescription) {
    if (originalMetaDescriptionElement) {
      originalMetaDescriptionElement.content = data?.metaDescription;
    } else {
      const metaDescriptionElement = document.createElement("meta");
      metaDescriptionElement.name = "description";
      metaDescriptionElement.content = data?.metaDescription;

      document.head.appendChild(metaDescriptionElement);
    }
  }

  if (data?.metaTitles) {
    document.title = data?.metaTitles;
  }
}
main();
